export default __webpack_public_path__ + "static/media/InnovativeSolution.cbd64541.png";